import {css, html} from 'lit';
import Base from '../base.js';

/**
 * @element inv-text-xxl
 */

/**
 * @attribute {"bold"|"semibold"|"medium"|"regular"|"light"} [weight="normal"] - optional, default value is "medium"
 */

/**
 * @cssproperty --inv-text-xxl-color - color
 * @cssproperty --inv-font-family - font-family
 * @cssproperty --inv-text-xxl-font-size - font-size
 * @cssproperty --inv-text-xxl-gradient - font-gradient
 * @cssproperty --inv-text-xxl-font-weight - font-weight
 */
export default class TextXxl extends Base {
    static get styles() {
        return css`
            :host {
                color: var(--inv-text-xxl-color, #00122b);
                font-family: var(--inv-font-family, 'Inter');
                font-weight: var(--inv-text-xxl-font-weight, 500);
                font-size: var(--inv-text-xxl-font-size, 1.8em);
                line-height: 130%;
                margin: 0 auto;
                background: var(--inv-text-xxl-gradient, var(--inv-text-xxl-color, #00122b));
                -webkit-background-clip: text;
                background-clip: text;
                -webkit-text-fill-color: transparent;
                width: fit-content;
            }
        `;
    }

    render() {
        return html`
            <slot role="heading" aria-level="4"></slot>
        `;
    }
}

TextXxl.register();
